export default function (payload) {
  if (parent === window) {
    return
  }

  parent.postMessage(payload, 'https://member.' + location.host.split('.').slice(1).join('.'))
}
